import http from "../../helpers/http";

import {
  FETCH_SHARE_STORY_CONTENT_SUCCESS,
  FETCH_SHARE_STORY_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("share-story")
    .then(({ data }) => {
      dispatch({
        type: FETCH_SHARE_STORY_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SHARE_STORY_CONTENT_FAILED,
        payload: error
      });
    });
};
